import $ from "jquery";
import EmblaCarousel from "embla-carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";

// `--slider-slides-to-scroll` on `.property-slider__embla` (inherited by viewport) — `_property-slider.scss`
export function slidesToScrollFromCss(viewportEl) {
  const raw = getComputedStyle(viewportEl)
    .getPropertyValue("--slider-slides-to-scroll")
    .trim();
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

/**
 * @param {HTMLElement} rootEl — `.property-slider` root (contains `__embla`, `__viewport`, arrows)
 */
export function initPropertySliderEmbla(rootEl) {
  const $root = $(rootEl);
  const $viewport = $root.find(".property-slider__viewport");
  if (!$viewport.length) {
    return;
  }

  const viewportEl = $viewport[0];

  const embla = EmblaCarousel(
    viewportEl,
    {
      slidesToScroll: slidesToScrollFromCss(viewportEl),
      align: "center",
      loop: true,
      containScroll: false,
    },
    [WheelGesturesPlugin()],
  );

  let lastSlidesToScroll = slidesToScrollFromCss(viewportEl);
  const ro = new ResizeObserver(() => {
    const next = slidesToScrollFromCss(viewportEl);
    if (next !== lastSlidesToScroll) {
      lastSlidesToScroll = next;
      embla.reInit({ slidesToScroll: next });
    }
  });
  ro.observe(viewportEl);

  $root
    .find(".property-slider__arrow--prev")
    .on("click", () => embla.scrollPrev());
  $root
    .find(".property-slider__arrow--next")
    .on("click", () => embla.scrollNext());
}
